const style = {
  sx: {
    mt: 1,
    backgroundColor: 'primary.main',
    textTransform: 'none',
  },
  type: 'submit',
  variant: 'contained',
} as const;

export default style;
